type ListingItem = { id?: string; data?: { url?: string } };

const normalizeUrl = (url: string) => url.replace(/\/+$/, '');

/**
 * Merges the live listing (Vercel Blob) with the copy bundled at build time,
 * keeping every entry once and preferring the live one.
 *
 * Entries are matched by Builder id first, then by URL. Matching by URL alone
 * treated a post whose slug had changed as two different posts: the live copy
 * had the new URL, the bundled copy the old one, and the listing showed the old
 * link (working only through its redirect). The id never changes with the slug.
 * The URL still counts, for bundles built before ids were fetched.
 */
export const mergeListings = <T extends ListingItem>(primary: T[], fallback: T[]): T[] => {
  const seenIds = new Set<string>();
  const seenUrls = new Set<string>();
  const result: T[] = [];

  const addItem = (item: T) => {
    const id = item?.id;
    const url = item?.data?.url ? normalizeUrl(item.data.url) : '';

    if ((!id && !url) || (id && seenIds.has(id)) || (url && seenUrls.has(url))) {
      return;
    }

    if (id) {
      seenIds.add(id);
    }

    if (url) {
      seenUrls.add(url);
    }

    result.push(item);
  };

  primary.forEach(addItem);
  fallback.forEach(addItem);

  return result;
};
